export const NationalityEnum = {
  lookupTypeId: 16,
};
